/**
 * This component is for cells with both Text and Icon.
 * If you want Text only cells then use `TextCell`.
 * If you want Icon only cells then use this one but with `text = ""`
 */

import classNames from "classnames";
import { isValidElement } from "react";
import styles from "./IconTextCell.module.scss";
import type { OwnProps } from "./types";

/**
 * @param icon can be a string which this component will interpret
 * as a `className`, or can be `ReactNode`
 * @param text can be simple as string or a ReactNode
 * @returns JSX element
 */
const IconTextCell = ({ className, icon, text }: OwnProps): JSX.Element => {
  return (
    <div className={classNames(styles.iconTextCell, className)}>
      <div>{text}</div>
      {isValidElement(icon) ? (
        icon
      ) : typeof icon === "string" ? (
        <div className={typeof icon === "string" ? icon : ""} />
      ) : null}
    </div>
  );
};

export default IconTextCell;
